import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const CardsIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='fi_5485099' enable-background='new 0 0 100 100' viewBox='0 0 100 100' fill={theme.palette.text.primary}
      height={props.width} width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <g>
          <path d='m51.4 80.4c-.3 0-.6.3-.6.6v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6z' />
          <path d='m49.5 84.6c.3-.2.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8l1.2 2.1c.1.2.5.3.8.2z' />
          <path d='m45.8 83.9c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8z' />
          <path d='m47.6 87.8c0-.3-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6h2.4c.3 0 .6-.3.6-.6z' />
          <path d='m48.1 89.7c-.2-.3-.5-.4-.8-.2l-2.1 1.2c-.3.2-.4.5-.2.8s.5.4.8.2l2.1-1.2c.3-.1.4-.5.2-.8z' />
          <path d='m49.5 91.1c-.3-.2-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.7.2.8.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.7-.2-.8z' />
          <path d='m51.4 91.6c-.3 0-.6.3-.6.6v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.4-.3-.6-.6-.6z' />
          <path d='m54.1 91.3c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8l1.2 2.1c.2.3.5.4.8.2s.4-.5.2-.8z' />
          <path d='m57.6 90.7-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8z' />
          <path d='m58.2 87.2h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6z' />
          <path d='m54.6 85.9c.2.3.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8s-.5-.4-.8-.2l-2.1 1.2c-.2.2-.3.5-.2.8z' />
          <path d='m55.1 81.4c-.3-.2-.7-.1-.8.2l-1.3 2.1c-.2.3-.1.7.2.8.3.2.7.1.8-.2l1.2-2.1c.3-.2.2-.6-.1-.8z' />
          <path
            d='m48.8 87.8c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6-2.6 1.2-2.6 2.6zm4 0c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4 1.4.6 1.4 1.4z'
          />
          <path d='m67.3 5.6c.3 0 .6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v2.4c0 .4.3.6.6.6z' />
          <path d='m64.6 5.9c.2.3.5.4.8.2s.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8z' />
          <path d='m61.1 6.5 2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8l-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8z' />
          <path d='m60.5 10h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6z' />
          <path d='m64 11.3c-.2-.3-.5-.4-.8-.2l-2.1 1.2c-.3.2-.4.5-.2.8s.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8z' />
          <path d='m63.6 15.8c.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.7-.2-.8-.3-.2-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.6.2.8z' />
          <path d='m66.7 13.8v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6s-.6.2-.6.6z' />
          <path d='m70.2 15.6c.2.3.5.4.8.2s.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8z' />
          <path d='m73.7 13.1c.2-.3.1-.7-.2-.8l-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.6.1.8-.2z' />
          <path d='m71.1 9.4c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.4c-.4 0-.6.3-.6.6z' />
          <path d='m70.6 7.5c.2.3.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8s-.5-.4-.8-.2l-2.1 1.2c-.3.1-.4.5-.2.8z' />
          <path d='m69.2 6.1c.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.6-.2-.8s-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.7.2.8z' />
          <path
            d='m69.9 9.4c0-1.4-1.2-2.6-2.6-2.6s-2.6 1.2-2.6 2.6 1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6zm-2.6 1.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4z'
          />
          <path d='m4.5 75.7c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z' />
          <path d='m9.5 81.7c.3-.3.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.2.3.7.3 1 0z' />
          <path d='m8.3 77.8 1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0z' />
          <path d='m4.6 79.5-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.2-1 0z' />
          <path d='m6 78.2c-.2.2-.2.6 0 .9.2.2.6.2.9 0 .2-.2.2-.6 0-.9-.3-.2-.6-.2-.9 0z' />
          <path d='m3.9 28.2c.3.3.7.3 1 0s.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1z' />
          <path d='m7.8 32.1c.3.3.7.3 1 0s.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1z' />
          <path d='m7.7 28.2 1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0z' />
          <path d='m3.8 32.1 1.2-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1 .2.3.6.3.9 0z' />
          <circle cx='5.8' cy='29.1' r='.6' />
          <path d='m70 87.8c-.4 0-.7.3-.7.7v1.6c0 .4.3.7.7.7s.7-.3.7-.7v-1.6c.1-.4-.3-.7-.7-.7z' />
          <path d='m70 93.3c-.4 0-.7.3-.7.7v1.6c0 .4.3.7.7.7s.7-.3.7-.7v-1.6c.1-.4-.3-.7-.7-.7z' />
          <path d='m73.6 91.4h-1.6c-.4 0-.7.3-.7.7s.3.7.7.7h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z' />
          <path d='m68.1 91.4h-1.6c-.4 0-.7.3-.7.7s.3.7.7.7h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z' />
          <circle cx='70' cy='92.1' r='.6' />
          <path d='m45.8 7.8c.4 0 .7-.3.7-.7v-1.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.6c0 .4.3.7.7.7z' />
          <path d='m45.8 13.3c.4 0 .7-.3.7-.7v-1.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.6c0 .4.3.7.7.7z' />
          <path d='m47.7 9.8h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.6c-.4-.1-.7.2-.7.6s.3.8.7.8z' />
          <path d='m42.3 9.8h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.6c-.4 0-.7.3-.7.7-.1.3.3.7.7.7z' />
          <path d='m45.8 8.4c-.3 0-.6.3-.6.6s.3.6.6.6.6-.3.6-.6-.2-.6-.6-.6z' />
          <path d='m30.1 87.8c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z' />
          <path d='m33.9 91.7c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z' />
          <path d='m34.1 87.8-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0z' />
          <path d='m30.2 91.7-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0z' />
          <path d='m31.6 90.4c-.2.2-.2.6 0 .9.2.2.6.2.9 0 .2-.2.2-.6 0-.9s-.6-.3-.9 0z' />
          <path
            d='m32.2 17.5c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zm0-4.8c.9 0 1.7.7 1.7 1.7 0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.8-1.7 1.7-1.7z'
          />
          <path
            d='m11.5 91.8c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1zm0 4.8c-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7s1.7.7 1.7 1.7c0 .9-.8 1.7-1.7 1.7z'
          />
          <path
            d='m93 74.2c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zm0-4.8c.9 0 1.7.7 1.7 1.7 0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7s.8-1.7 1.7-1.7z'
          />
          <path
            d='m91.6 33.4c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1zm4.7 0c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7s1.7.8 1.7 1.7z'
          />
          <path
            d='m9.4 11.8c.2.2.3.5.2.7l-.6 2.8c-.2.7.5 1.2 1.2.9l2.6-1.2c.2-.1.5-.1.8 0l2.5 1.5c.6.4 1.3-.1 1.3-.8l-.3-2.9c0-.3.1-.5.3-.7l2.2-1.9c.3-.4.1-1.2-.6-1.3l-2.9-.6c-.3-.1-.5-.2-.6-.5l-1.2-2.7c-.3-.6-1.2-.7-1.5-.1l-1.4 2.5c-.1.3-.3.5-.6.5l-2.9.3c-.7.1-1 .9-.5 1.4z'
          />
          <path
            d='m95.5 87.1-2.9-.6c-.3-.1-.5-.2-.6-.5l-1.2-2.7c-.3-.6-1.2-.7-1.5-.1l-1.4 2.5c-.1.2-.4.4-.7.4l-2.9.3c-.7.1-1 .9-.5 1.4l2 2.1c.2.2.3.5.2.7l-.6 2.8c-.2.7.5 1.2 1.2.9l2.6-1.2c.2-.1.5-.1.8 0l2.5 1.5c.6.4 1.3-.1 1.3-.8l-.3-2.9c0-.3.1-.5.3-.7l2.2-1.9c.4-.2.1-1-.5-1.2z'
          />
          <path
            d='m87.6 25.9h.2c0-3.8 3.1-6.9 6.9-6.9v-.2c-2.2 0-4.7-1.2-6-3.4-.6-1-1-2.2-1-3.5h-.2c0 3.8-3.1 6.9-6.9 6.9v.2c1.2 0 2.3.3 3.3.9 1.7.6 3.7 3.3 3.7 6z'
          />
          <path
            d='m96.3 45.3-21.8-13.1c-.2-.1-.5-.2-.7-.2-.1 0-.2 0-.3 0-.4.1-.7.3-.9.6l-21.5 36c-.4.7-.2 1.5.5 1.9l21.8 13.1c.3.2.7.3 1.1.2s.7-.3.9-.6l21.5-35.9c.3-.7.1-1.6-.6-2zm-15.6 17.4c-.7 1.7-1.9 2.9-3.8 3.3-1.4.3-2.5-.5-3.5-1.4-.5-.5-.8-1-1.2-1.6-.4.7-1.1 1.4-1 2.4.1.8.1 1.6.2 2.5-1.7-1-3.4-2-5.2-3.1.8-.4 1.6-.7 2.4-1.1.9-.4 1.2-1.2 1.7-2-.2 0-.3 0-.4 0-1.2 0-2.4-.3-3.4-1-1.3-.9-1.5-2.3-1.3-3.7.3-2.2 1.7-3.5 3.6-4.4 2.1-1.1 4.4-1.8 6.8-2.3 1.1-.3 2.3-.5 3.4-.8.8 2.7 1.6 5.3 1.9 8.1.2 1.7.4 3.4-.2 5.1z'
          />
          <path
            d='m39.9 63 10.1 3.3 7.4-12.3c-.3.1-.6.2-.9.3s-.5.1-.7-.2c-1.9-2.6-3.5-5.4-4.5-8.5-.5-1.8-.8-3.5-.5-5.4.6-3.3 3.3-5 5.9-4.7 1.6.2 2.8 1.1 3.4 2.6.2.6.4 1.2.6 1.8.4-.3.8-.5 1.2-.8 1.4-1.2 3.1-1.2 4.6-.5l4.3-7.1c.5-.8 1.2-1.4 2.1-1.6s1.8-.1 2.6.4l2.7 1.6.6-1.8c.1-.4.1-.7-.1-1.1-.2-.3-.5-.6-.8-.7l-24.1-7.9c-.4-.1-.7-.1-1.1.1-.3.2-.6.5-.7.8l-13 39.9c-.2.8.2 1.6.9 1.8z'
          />
          <path
            d='m46 70.7-12.6 3.3c-.3 0-.6 0-.9 0-1.5 0-3-1-3.4-2.6l-1.6-6c-3.7-1.6-7.4-3.3-11.1-4.9 1.1-4.3 2.1-8.6 3.2-13 1.2.6 2.5 1.1 3.7 1.7l-3.9-15.1-16.4 8.1c-.7.3-1 1.2-.7 1.9l18.4 37.6c.2.3.5.6.8.7.4.1.7.1 1.1-.1l22.8-11.2c.3 0 .4-.2.6-.4z'
          />
          <path
            d='m31.1 70.9c.2.8 1 1.2 1.7 1l14-3.6h.1.1l1.3-.3-9-3c-1.8-.6-2.8-2.6-2.2-4.4l2.6-7.8c0-.1 0-.1-.1-.2-1.7 2.1-3.7 2.8-6.2 1.5-1.7-.9-2.6-2.7-2.3-4.6.4-2.4 1.9-3.6 4.3-4-1.2-1-1.8-2.2-1.8-3.7 0-1.1.3-2.1 1-3 1.3-1.8 3.7-2.3 5.7-1.4 2.2 1 3 3 2.5 5.9l5.8-17.7-.6-2.3c-.2-.8-1-1.2-1.7-1l-24.6 6.4c-.8.2-1.2 1-1 1.7z'
          />
        </g>
      </g>
    </svg>
  )
}
export default CardsIcon
